angular.module('app').config(featureCategoriesRouting);

function featureCategoriesRouting($routeProvider) {
  $routeProvider.when('/feature_categories', {
    pageTitle: 'FEATURE_CATEGORIES',
    template: '<feature-categories-page></feature-categories-page>',
    menu: 'features',
    accessPermission: 'index_feature_superadmin',
    authReq: true,
  });
}

featureCategoriesRouting.$inject = ['$routeProvider'];
